import { Store } from "vuex";
import { InjectionKey, Ref } from "vue";
import { RootState } from "@/types/root-type";

export const session_key = Symbol() as InjectionKey<Ref<boolean>>;
export const terms_key = Symbol() as InjectionKey<Ref<boolean>>;
export const collapse_key = Symbol() as InjectionKey<Ref<boolean>>;
export const store_key = Symbol() as InjectionKey<Store<RootState>>;
